import { Component, OnInit } from '@angular/core';
import { InventoryCampaignDetailsForm } from '../inventory-campaign-details-form/inventory-campaign-details-form';
import { InventoryCampaignDetailsTable } from '../inventory-campaign-details-table/inventory-campaign-details-table';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-inventory-campaign-details',
  standalone: true,
  imports: [InventoryCampaignDetailsForm, InventoryCampaignDetailsTable],
  templateUrl: './inventory-campaign-details.html',
  styleUrl: './inventory-campaign-details.scss',
})
export class InventoryCampaignDetails implements OnInit {
  isBackButtonPresent: boolean = false;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService
  ) {}
  columnName: string = '';
  Value: any = '';
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      console.log(params);
      this.columnName = params['column'] || '';
      this.Value = params['value'] || '';

      const fromMarketViaParams =
        this.columnName === 'Market' && String(this.Value).length >= 5;
      const fromVcdBackInMarketFlow =
        this.commonService.vcdBackButtonActivated.getValue() &&
        !!this.commonService.regionalScreenSelectedValue.getValue();
      const showBackButton = fromMarketViaParams || fromVcdBackInMarketFlow;

      this.isBackButtonPresent = showBackButton;
      this.commonService.isBackButtonPresent.next(showBackButton);
      console.log('isBackButtonPresent:', this.isBackButtonPresent);
    });
  }
}
